/*
  Reczne wpisywanie wartosci pod suwakami filtrow.

  Liczby pod suwakiem (cena, szerokosc, dlugosc...) byly tylko podpisem. Teraz
  kazda z nich jest klikalna: klikniecie (albo Enter z klawiatury) zamienia ja
  w pole, w ktore wpisuje sie wartosc, a Enter lub wyjscie z pola zatwierdza.
  Escape wycofuje zmiane.

  Dwie zasady, ktore trzymaja to przy zyciu:

  1. Nie liczymy nic sami - po zatwierdzeniu ustawiamy suwak i puszczamy DOKLADNIE
     te same zdarzenia, ktore leca przy przeciaganiu uchwytu. Dzieki temu podpisy,
     sklejka pod naglowkiem filtru, licznik produktow i zaznaczenia pol wyboru
     (w filtrach wymiarowych) aktualizuja sie istniejacymi sciezkami.
  2. Wpisana liczba jest DOCIAGANA do najblizszej wartosci, ktora suwak zna.
     Filtry wymiarowe maja skokowa liste wartosci (140, 145, 150...), a biblioteka
     suwaka po cichu ignoruje wartosc, ktorej nie ma na liscie.

  Pulapka: podpis pod suwakiem jest NADPISYWANY przez komponent suwaka przy kazdym
  ruchu uchwytu (przez `innerHTML`), dlatego pole do wpisywania nie moze byc jego
  dzieckiem - stoi obok jako rodzenstwo i tylko podmieniamy, ktore z dwojga widac.

  Pulapka: biblioteka suwaka ignoruje wartosc 0 podana do `setValues` (sprawdza ja
  jak zwykla nieprawde), a dolna granica ceny to wlasnie 0. Dlatego ustawiamy
  polozenia uchwytow wprost i wolamy `setValues` bez argumentow - to tylko
  przelicza pozycje i zglasza zmiane.
*/
if (!window.cossyFilterRangeInput) {
  window.cossyFilterRangeInput = true;

  (() => {
    const ZNACZNIK = "cossyManualInput";

    // "8 745 zl" -> 8745 ; "369 cm" -> 369 ; "1 234,50" -> 1234.5
    const liczbaZTekstu = (tekst) => {
      const czysty = String(tekst)
        .replace(/\s| /g, "")
        .replace(/[^\d,.-]/g, "")
        .replace(",", ".");
      const wynik = parseFloat(czysty);
      return isNaN(wynik) ? null : wynik;
    };

    const dostepneWartosci = (komponent) => {
      const conf = komponent.slider && komponent.slider.conf;
      return conf && Array.isArray(conf.values) ? conf.values : null;
    };

    // najblizsza wartosc z listy suwaka - patrz zasada 2 w komentarzu wyzej
    const indeksNajblizszej = (wartosci, liczba) => {
      let najlepszy = 0;
      let najmniejszaRoznica = Infinity;

      for (let i = 0; i < wartosci.length; i += 1) {
        const roznica = Math.abs(Number(wartosci[i]) - liczba);
        if (roznica < najmniejszaRoznica) {
          najmniejszaRoznica = roznica;
          najlepszy = i;
        }
      }

      return najlepszy;
    };

    const zastosuj = (komponent, koniec, liczba) => {
      const suwak = komponent.slider;
      const wartosci = dostepneWartosci(komponent);
      if (!suwak || !wartosci) return;

      let poczatek = suwak.values.start;
      let kraniec = suwak.values.end;
      const nowy = indeksNajblizszej(wartosci, liczba);

      if (koniec === "from") poczatek = Math.min(nowy, kraniec);
      else kraniec = Math.max(nowy, poczatek);

      suwak.values.start = poczatek;
      suwak.values.end = kraniec;

      if (komponent.tagName === "RANGE-SLIDER") {
        // 1. przesun uchwyty bez zglaszania zmiany, 2. daj komponentowi zdarzenie
        // wejscia (to on przepisuje wartosci do pol i podpisow), 3. dopiero
        // zglos zmiane - sklejka pod naglowkiem czyta gotowe podpisy
        suwak.setValues(null, null, false);
        const pole = komponent.querySelector("[data-range]");
        if (pole) pole.dispatchEvent(new Event("input"));
        suwak.onChange();
      } else {
        // filtry wymiarowe robia cala reszte w swojej obsludze zmiany
        suwak.setValues(null, null, true);
      }
    };

    const przygotuj = (etykieta, komponent, koniec) => {
      if (etykieta.dataset[ZNACZNIK]) return;
      etykieta.dataset[ZNACZNIK] = "1";

      const pole = document.createElement("input");
      pole.type = "text";
      pole.inputMode = "decimal";
      pole.hidden = true;
      pole.className = "filters__range-input filters__range-input--" + koniec;
      etykieta.after(pole);

      etykieta.classList.add("filters__range-value");
      etykieta.setAttribute("role", "button");
      etykieta.setAttribute("tabindex", "0");

      // Ukrycie pola, w ktorym stoi kursor, samo wywoluje zdarzenie utraty
      // ogniska - a na nim wisi zatwierdzanie. Bez tej flagi Escape wygladal
      // jak zatwierdzenie: pole sie zamykalo i chwile pozniej i tak wpisywal
      // wartosc, ktora user wlasnie wycofal.
      let anulowane = false;

      const wlacz = () => {
        anulowane = false;
        const liczba = liczbaZTekstu(etykieta.textContent);
        pole.value = liczba === null ? "" : String(liczba);
        etykieta.hidden = true;
        pole.hidden = false;
        pole.focus();
        pole.select();
      };

      const wylacz = () => {
        pole.hidden = true;
        etykieta.hidden = false;
      };

      const anuluj = () => {
        anulowane = true;
        wylacz();
      };

      const zatwierdz = () => {
        if (anulowane) {
          anulowane = false;
          return;
        }

        const liczba = liczbaZTekstu(pole.value);
        const obecna = liczbaZTekstu(etykieta.textContent);
        wylacz();

        // ta sama wartosc = nie zawracamy glowy przeliczaniem listy produktow
        if (liczba === null || liczba === obecna) return;
        zastosuj(komponent, koniec, liczba);
      };

      etykieta.addEventListener("click", wlacz);
      etykieta.addEventListener("keydown", (zdarzenie) => {
        if (zdarzenie.key !== "Enter" && zdarzenie.key !== " ") return;
        zdarzenie.preventDefault();
        wlacz();
      });

      pole.addEventListener("keydown", (zdarzenie) => {
        if (zdarzenie.key !== "Enter" && zdarzenie.key !== "Escape") return;

        zdarzenie.preventDefault();
        // Escape jest w motywie skrotem zamykajacym szuflade (nasluch na
        // dokumencie), a Enter potrafi zatwierdzic formularz - wewnatrz pola
        // oba maja znaczyc tylko "zatwierdz" albo "wycofaj", wiec zatrzymujemy
        // je tutaj. Bez tego Escape wycofywal wpisana wartosc i JEDNOCZESNIE
        // zamykal cala szuflade filtrow.
        zdarzenie.stopPropagation();

        if (zdarzenie.key === "Enter") zatwierdz();
        else anuluj();
      });

      pole.addEventListener("blur", zatwierdz);
    };

    const przejrzyj = () => {
      document.querySelectorAll("range-slider, value-range").forEach((komponent) => {
        const od = komponent.querySelector("[data-from-text]");
        const doWartosc = komponent.querySelector("[data-to-text]");
        if (od) przygotuj(od, komponent, "from");
        if (doWartosc) przygotuj(doWartosc, komponent, "to");
      });
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", przejrzyj);
    } else {
      przejrzyj();
    }

    // listing bywa podmieniany bez przeladowania strony (filtry, sortowanie),
    // wiec nowe suwaki trzeba przygotowac ponownie
    window.addEventListener("filtersUpdated", przejrzyj);
    document.addEventListener("shopify:section:load", przejrzyj);
  })();
}
